function CRUDTableRow({children}) {
    return (
      <tr>{children}</tr>
    )
  }
  
  export default CRUDTableRow